import { homepageNews } from 'components/NewsCards/mockData';
import NewsCard from 'components/NewsCards/NewsCard';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import { Button } from 'components/buttons/Button/Button';
import './styles.scss';
import useMediaQuery from 'hooks/useMediaQuery';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import React from 'react';
import { newsSlides } from 'components/NewsCards/mockData';

const LatestNews = () => {
    const modules = [Pagination];

    const breakpoints = {
        320: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 2,
        },
    };
    const isTablet = useMediaQuery('max-width: 1023px');

    return (
        <section>
            <div className="container">
                <div className="inner-container with-top-offset">
                    <div className="up-to-date">
                        <div className="head">
                            <div>
                                <LabelButton>STAY UP TO DATE</LabelButton>
                            </div>
                            <h2>Latest research, news & events</h2>
                        </div>
                        <div className="up-to-date-description-wrapper">
                            <div className="up-to-date-description">
                                <p className="description-medium">
                                    <span>We're constantly</span> publishing fresh news and research
                                    <span>, that will help expand your knowledge of the current</span> challenges in the
                                    agricultural industry.
                                </p>
                                <Button type="learn-more-arrow">VIEW ALL NEWS</Button>
                            </div>

                            {isTablet ? (
                                <div className="news-slider">
                                    <Swiper pagination modules={modules} breakpoints={breakpoints} spaceBetween={8}>
                                        {newsSlides.map(item => (
                                            <SwiperSlide key={item.title}>
                                                <NewsCard data={item} />
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </div>
                            ) : (
                                <div className="latest-cards-container">
                                    {homepageNews.map(card => (
                                        <NewsCard key={card.title} data={card} />
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
export default LatestNews;
